import React, { useState, useEffect } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment/moment'
import { useTranslation } from 'react-i18next'

import Select from 'components/Form/Select/Select'

import calendarIcon from './i/calendar.svg'

import { getOptions } from './utils'

import { MINUTES_STEP } from './constants'

import './DatePicker.scss'

class CustomDatePicker extends React.Component {
    render() {
        const { value, onClick } = this.props

        return (
            <div className="content input" onClick={onClick}>
                <input type="text" readOnly value={moment(value).format('DD.MM.YYYY')} />
                <img className="date-picker__icon" src={calendarIcon} alt="calendar" />
            </div>
        )
    }
}

const DatePickerControl = ({ value, onUpdate, id, otherValues, name, schema: { label = '', min, max, payload } }) => {
    const { t } = useTranslation()

    const [minDate, setMinDate] = useState(null)
    const [maxDate, setMaxDate] = useState(null)

    useEffect(() => {
        if (payload?.minDateKey) {
            const el = otherValues.find(item => item.name === payload.minDateKey)
            if (el) setMinDate(el.value)
        } else {
            setMinDate(min)
        }

        if (payload?.maxDateKey) {
            const el = otherValues.find(item => item.name === payload.maxDateKey)
            if (el) setMaxDate(el.value)
        } else {
            setMaxDate(max)
        }
    }, [payload, otherValues])

    useEffect(() => {
        if (minDate === value) {
            onChange(moment(minDate).add(MINUTES_STEP, 'minutes').valueOf())
        }
    }, [minDate, value])

    const onChange = newValue => {
        if (minDate && minDate > newValue) {
            onUpdate(id, { [name]: minDate })
            return
        }
        if (maxDate && maxDate < newValue) {
            onUpdate(id, { [name]: maxDate })
            return
        }

        onUpdate(id, { [name]: newValue })
    }

    return (
        <div className="control-box">
            <div className="date-picker">
                <div className="date-picker__block">
                    <p className="date-picker__block__title">{label}</p>
                    <DatePicker
                        maxDate={maxDate}
                        minDate={minDate}
                        selected={value}
                        onChange={v => onChange(moment(v).valueOf())}
                        customInput={<CustomDatePicker />}
                    />
                </div>
                <div className="date-picker__block">
                    <p className="date-picker__block__title">{t('Time')}</p>
                    <div className="date-picker__time-picker">
                        <Select
                            maxHeight={120}
                            value={{
                                value: moment(value).valueOf(),
                                label: moment(value).format('HH:mm'),
                            }}
                            options={getOptions(value, minDate, maxDate)}
                            onUpdate={v => onChange(v.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DatePickerControl
